/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OrderRefundResponsibility = {
    DEVOUR: 'DEVOUR',
    MERCHANT: 'MERCHANT',
    DELIVERY_PROVIDER: 'DELIVERY_PROVIDER',
    SYSTEM_CANCELLED: 'SYSTEM_CANCELLED',
    CUSTOMER: 'CUSTOMER'
} as const;
export type OrderRefundResponsibility = typeof OrderRefundResponsibility[keyof typeof OrderRefundResponsibility];


export function instanceOfOrderRefundResponsibility(value: any): boolean {
    for (const key in OrderRefundResponsibility) {
        if (Object.prototype.hasOwnProperty.call(OrderRefundResponsibility, key)) {
            if (OrderRefundResponsibility[key as keyof typeof OrderRefundResponsibility] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OrderRefundResponsibilityFromJSON(json: any): OrderRefundResponsibility {
    return OrderRefundResponsibilityFromJSONTyped(json, false);
}

export function OrderRefundResponsibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderRefundResponsibility {
    return json as OrderRefundResponsibility;
}

export function OrderRefundResponsibilityToJSON(value?: OrderRefundResponsibility | null): any {
    return value as any;
}

export function OrderRefundResponsibilityToJSONTyped(value: any, ignoreDiscriminator: boolean): OrderRefundResponsibility {
    return value as OrderRefundResponsibility;
}

